import React from 'react';
import PropTypes from 'prop-types';
import { interpolate } from '../../cms';
import { getPronoun, PRONOUN_TYPES } from '../../pets';
import { StyledCheckoutText } from './styles';

export const CheckoutText = ({ plans }) => {
  return (
    <StyledCheckoutText>
      {Boolean(plans.length) &&
        plans.map(({ petName, gender, frequency }) =>
          interpolate(
            `After {{petName}}'s starter box, {{petPronoun}} plan will be billed and shipped every {{frequency}} weeks. `,
            {
              petName,
              petPronoun: getPronoun(gender, {
                type: PRONOUN_TYPES.POSSESSIVE_ADJECTIVE,
                perspective: 3,
              }),
              frequency,
            },
          ),
        )}
    </StyledCheckoutText>
  );
};

CheckoutText.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
};
